<template>
    <b-col lg="9">
        <router-link :to="{name: pathName, params: params}">
            <button type="button"
                    class="btn btn-standard-gradient px-4 float-right mt-0 mb-3"
                    v-if="showAddButton"
            >
                <i class="fas fa-plus-circle mr-2"></i>{{nameButton}}
            </button>
        </router-link>
    </b-col>
</template>

<script>
    export default {
        name: 'TableAddButton',
        props: {
            showAddButton: Boolean,
            pathName: String,
            nameButton: String,
            params: {
                type:Object,
                default(){
                    return{};
                }
            }
        }
    };
</script>

<style scoped>

</style>
